// extracted by mini-css-extract-plugin
export default {"content-wrapper":"FetchDataDescription_content-wrapper__qniLX","description":"FetchDataDescription_description__LlzHO"};